import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "../../../components/Button";

const BootstrapModal = ({
  show,
  title,
  content,
  loading,
  handleClose,
  handleSubmit,
  showClose = true,
}) => {
  return (
    <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton={showClose}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{content}</Modal.Body>
      <Modal.Footer>
        <Button title={"No"} disabled={loading} handleClick={handleClose} />
        <Button title={"Yes"} disabled={loading} handleClick={handleSubmit} />
      </Modal.Footer>
    </Modal>
  );
};

export default BootstrapModal;
